var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAddToBasket = function SvgIconAddToBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-addToBasket",
    transform: "translate(84 -8710)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    width: 24,
    height: 24,
    transform: "translate(-84 8734) rotate(-90)",
    fill: "#2b3031",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M-724,18a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3A3,3,0,0,1-724,18Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-724,14Zm-9,4a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3A3,3,0,0,1-733,18Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-733,14Zm9.5-3h-3.081a1,1,0,0,1-1-1,1,1,0,0,1,1-1h2.336l2.919-10H-735.18l.6,3h-2.039l-1.2-6H-740a1,1,0,0,1-1-1,1,1,0,0,1,1-1h3a1,1,0,0,1,.981.8l.439,2.2H-720a1,1,0,0,1,.8.4,1.006,1.006,0,0,1,.163.877l-2,7a.126.126,0,0,1,0,.017l-1.5,5A.993.993,0,0,1-723.5,11Zm-7.5-1a.99.99,0,0,1-.707-.292A.994.994,0,0,1-732,9a.993.993,0,0,1,.293-.707L-729.414,6H-739a1,1,0,0,1-1-1,1,1,0,0,1,1-1h9.586l-2.293-2.293A.993.993,0,0,1-732,1a.994.994,0,0,1,.293-.707A.993.993,0,0,1-731,0a.993.993,0,0,1,.707.293l4,4A.994.994,0,0,1-726,5a.992.992,0,0,1-.293.707l-4,4A.992.992,0,0,1-731,10Z",
    transform: "translate(657.001 8716)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddToBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-addToBasket.c36e3563.svg";
export { ForwardRef as ReactComponent };